import { PREFIX as STORAGE_PREFIX } from '../constants';
import { InMemoryStorageAdapter, SessionStorageAdapter, } from './StorageAdapter';
import { isSessionStorageSupported } from './utils';
var defaultStorageManagerOptions = {
    requiresPersistingState: false
};
export var StorageAdapterType;
(function (StorageAdapterType) {
    StorageAdapterType["IN_MEMORY"] = "in-memory";
    StorageAdapterType["SESSION_STORAGE"] = "session-storage";
    StorageAdapterType["CUSTOM_STORAGE"] = "custom-storage";
})(StorageAdapterType || (StorageAdapterType = {}));
var StorageManager = (function () {
    function StorageManager(options) {
        if (options === void 0) { options = defaultStorageManagerOptions; }
        this.storageAdapter = new InMemoryStorageAdapter();
        if (options.requiresPersistingState) {
            if (options.storageAdapter) {
                this.storageAdapter = options.storageAdapter;
            }
            else if (isSessionStorageSupported()) {
                this.storageAdapter = new SessionStorageAdapter();
            }
        }
    }
    StorageManager.prototype.getItem = function (key) {
        return this.storageAdapter.getItem("".concat(STORAGE_PREFIX).concat(key));
    };
    StorageManager.prototype.setItem = function (key, value) {
        var itemToStore = value || '';
        this.storageAdapter.setItem("".concat(STORAGE_PREFIX).concat(key), itemToStore);
    };
    StorageManager.prototype.removeItem = function (key) {
        this.storageAdapter.removeItem("".concat(STORAGE_PREFIX).concat(key));
    };
    StorageManager.prototype.clear = function () {
        this.storageAdapter.clear();
    };
    StorageManager.prototype.getStorageType = function () {
        if (this.storageAdapter instanceof InMemoryStorageAdapter) {
            return StorageAdapterType.IN_MEMORY;
        }
        else if (this.storageAdapter instanceof SessionStorageAdapter) {
            return StorageAdapterType.SESSION_STORAGE;
        }
        return StorageAdapterType.CUSTOM_STORAGE;
    };
    return StorageManager;
}());
export { StorageManager };
//# sourceMappingURL=StorageManager.js.map